// extracted by css-extract-rspack-plugin
export default {"content":"content-bH0JPw","text":"text-FGtT5z","companies":"companies-F8m4Ai"};